<div class="modal-header">
    <h2 class="modal-title">{{ azione }} Rilievo</h2>
    <button class="close" type="button" aria-label="Chiudi" (click)="activeModal.close()" tabindex="0">
        <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
    </button>
</div>
<div class="modal-body">
    <form class="form" role="form" [formGroup]="criteriaForm">
        <ngb-accordion aria-busy="true" #acc="ngbAccordion" activeIds="tab-1">
            <ngb-panel id="tab-1" title="Associa/Inserisci rilievo*">
                <ng-template ngbPanelContent>
                    <p class="border-bottom mb-2 pb-2">È possibile selezionare il Rilievo ricercandolo tramite l'apposito form, oppure inserendone uno nuovo attraverso il pulsante "Inserisci rilievo".</p>
                    <ng-container *ngIf="currentRilievo">
                        <h6>Rilievo selezionato</h6>
                        <p>Nome: <strong>{{ currentRilievo.nome }}</strong></p>
                        <p>Soggetto esecutore del rilievo: <strong>{{ currentRilievo.soggettoEsecutore }}</strong></p>
                        <p>Descrizione: <strong>{{ currentRilievo.descrizione }}</strong></p>
                        <button *ngIf="canEdit" type="button" class="btn btn-sm btn-outline-primary" (click)="resetFormRicercaRilievo()">Cambia rilievo</button>
                    </ng-container>
                    <ng-container *ngIf="!currentRilievo" formGroupName="ricercaRilievoDTO">
                        <div class="border-bottom mb-2 pb-2">
                            <button type="button" class="btn btn-sm btn-primary" (click)="creaRilievo(modalCreaRilievo)">Inserisci rilievo</button>
                        </div>
                        <div class="form-row pt-2">
                            <h6 class="col-12">Ricerca Rilievo</h6>
                            <div class="form-group col-md-3">
                                <label for="idRilievo">ID rilievo</label>
                                <input class="form-control" id="idRilievo" formControlName="idRilievo" type="number">
                            </div>
                            <div class="form-group col-md-3">
                                <label for="nome">Nome rilievo</label>
                                <input class="form-control" id="nome" formControlName="nome" type="text">
                            </div>
                            <div class="form-group col-md-6">
                                <app-toolkit-datepicker
                                    id="dataInizioRilievo"
                                    label="Data inizio rilievo (a partire da)"
                                    formControlName="dataInizioRilievo"
                                    [disabled]="ricercaRilievoDTO.controls['dataInizioRilievo'].disabled">
                                </app-toolkit-datepicker>
                            </div>
                            <div class="form-group col-md-6">
                                <app-toolkit-datepicker
                                    id="dataFineRilievo"
                                    label="Data fine rilievo (entro il)"
                                    formControlName="dataFineRilievo"
                                    [disabled]="ricercaRilievoDTO.controls['dataFineRilievo'].disabled">
                                </app-toolkit-datepicker>
                            </div>
                        </div>
                        <div class="button-actions">
                            <button type="button" class="btn btn-sm btn-outline-primary" (click)="resetFormRicercaRilievo()">Pulisci</button>
                            <button type="button" class="btn btn-sm btn-primary" (click)="submitFormRicercaRilievo(true)">Ricerca</button>
                        </div>
                        <h6 id="table_description" class="sr-only">Risultati ricerca</h6>
                        <div style="transform: rotateX(180deg);" class="table-responsive mb-3">
                            <table style="transform: rotateX(180deg);" class="table table-striped table-sm" aria-describedby="table_description">
                                <thead class="thead-light">
                                    <tr>
                                        <th scope="col">ID</th>
                                        <th scope="col">Nome rilievo</th>
                                        <th scope="col">Soggetto esecutore</th>
                                        <th scope="col">Data inizio</th>
                                        <th scope="col">Data fine</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of tableDataRilievo">
                                        <td>{{ item.idRilievo }}</td>
                                        <td>{{ item.nome }}</td>
                                        <td>{{ item.soggettoEsecutore }}</td>
                                        <td>{{ item.dataInizioRilievo | date: 'dd/MM/yyyy' }}</td>
                                        <td>{{ item.dataFineRilievo | date: 'dd/MM/yyyy' }}</td>
                                        <td class="actions">
                                            <button aria-label="seleziona rilievo" class="btn btn-sm btn-outline-primary" (click)="selezionaRilievo(item)">Seleziona</button>
                                        </td>
                                    </tr>
                                    <tr *ngIf="!tableDataRilievo.length">
                                        <td colspan="6"><p class="mb-0 text-center">Nessun risultato trovato.</p></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <ngb-pagination
                            *ngIf="tableDataRilievo.length"
                            [(page)]="paginatorRilievo.page"
                            [pageSize]="paginatorRilievo.size"
                            [collectionSize]="paginatorRilievo.total"
                            [maxSize]="5"
                            (pageChange)="onPageChangeRilievo($event)"></ngb-pagination>
                    </ng-container>
                </ng-template>
            </ngb-panel>
        </ngb-accordion>
    </form>
    <p class="mt-3"><strong>* Campi obbligatori.</strong></p>
</div>
<div class="modal-footer">
    <button type="button" tabindex="0" (click)="activeModal.close()" class="btn btn-outline-primary">Chiudi</button>
    <button *ngIf="canEdit" type="button" tabindex="0" (click)="savePianoRilievi()" class="btn btn-primary">Salva</button>
</div>
<ng-template #modalCreaRilievo let-modalCreaRilievo>
    <div class="modal-header">
        <h4 class="modal-title">Inserisci nuovo rilievo</h4>
        <button type="button" class="close" aria-label="Close" (click)="modalCreaRilievo.close()">
            <app-toolkit-bl-icon icon="close-big"></app-toolkit-bl-icon>
        </button>
    </div>
    <div class="modal-body">
        <app-toolkit-rilievo-tab-anagrafica-rilievo [canEdit]="true" [formGroup]="inserisciRilievoDTO"></app-toolkit-rilievo-tab-anagrafica-rilievo>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary" (click)="modalCreaRilievo.close()">Chiudi</button>
        <button type="button" class="btn btn-primary" (click)="creaRilievo_confirm()">Inserisci</button>
    </div>
</ng-template>